import {configureStore} from '@reduxjs/toolkit'

import userSlice from './Slice/userSlice'
import passwordSlice from './Slice/passwordSlice'
import generalSlice from './Slice/generalSlice'
import academicSlice from './Slice/academicSlice'
import chatSlice from './Slice/chatSlice'
import adminSlice from './Slice/adminSlice'

export const store = configureStore({
  reducer: {
    user: userSlice,
    passwordSlice: passwordSlice,
    general: generalSlice,
    academic: academicSlice,
    chat: chatSlice,
    admin: adminSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
